import { defineStyleConfig } from '@chakra-ui/react';
import buttonSizes from './button.sizes';
import buttonVariants from './button.variants';

export default defineStyleConfig({
  baseStyle: {
    borderRadius: '5px',
    padding: '16px 24px',
    gap: '8px',
    fontWeight: 600,
    _focus: {
      outline: 'none',
      boxShadow: 'none',
    },
    _disabled: {
      filter: 'saturate(0)',
      cursor: 'auto',
    },
  },
  sizes: buttonSizes,
  variants: buttonVariants,
});
